// extracted by mini-css-extract-plugin
export default {"webgl-test":"styles_webgl-test__JnogZ"};